/* unplugin-vue-components disabled */import { render } from "./serviceClose.vue?vue&type=template&id=26b828ba"
import script from "./serviceClose.vue?vue&type=script&lang=js"
export * from "./serviceClose.vue?vue&type=script&lang=js"

import "./serviceClose.vue?vue&type=style&index=0&id=26b828ba&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/disney-mobile-ui-production-environment/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__